module.exports = __webpack_public_path__ + "assets/img/tick.decb9ab2f275c081053ab13f98dc9313.svg";